import React, { Component } from 'react';
import Nav from './../components/Nav';
import Taslak from '../components/Taslak';
import { database, auth } from '../firebase';
var randomstring = require('randomstring');

class Taslaklar extends Component {
  constructor(props) {
    super(props);
    this.database = database.ref().child('drafts');
    this.state = {
      drafts: [],
      showNoDraftsMessage: false, // To control visibility of "Burada taslaklarını görebilirsin" message
      showLoading: true, // To control visibility of loading image
      buttonLabel: "", // To manage the label of the "Yeni Taslak" button
    };
  }

  componentDidMount() {
    auth.onAuthStateChanged(function(user) {
      if (user === null) return window.location.pathname = "/giris-yap";
      database.ref("users/" + user.uid).get().then(snap => {
        if (snap.val().verified === undefined) return window.location.pathname = "/";
      })
    });

    const previousDrafts = this.state.drafts;
    auth.onAuthStateChanged((user) => {
      database.ref("drafts").child(user.uid).orderByChild("draftDate").on('child_added', snap => {
        previousDrafts.push({
          id: snap.key,
          draftTitle: snap.val().draftTitle,
          draftContent: snap.val().draftContent,
          draftImage: snap.val().draftImage,
          draftAuthor: snap.val().draftAuthor,
          draftShared: snap.val().draftShared
        });

        this.setState({
          drafts: previousDrafts,
        });
      });

      this.database.child(user.uid).get().then(function(snap) {
        if (!snap.exists()) {
          this.setState({ 
            showNoDraftsMessage: true, // Show "Burada taslaklarını görebilirsin."
            showLoading: false // Hide the loading icon
          });
        }
      }.bind(this));
    });

    if ((typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1)) {
      this.setState({ buttonLabel: "+" }); // Update the button label for mobile devices
    } else {
      this.setState({ buttonLabel: "Yeni Taslak Oluştur" }); // Update for non-mobile devices
    }
  }

  yeniYazi() {
    var newID = randomstring.generate(5);

    database.ref("drafts/"+auth.currentUser.uid+"/"+newID).set({
      draftTitle: "",
      draftContent: "",
      draftDate: Date.now(),
      draftImage: "",
      draftAuthor: auth.currentUser.uid,
      draftShared: false
    });

    window.location.pathname = "/taslak/"+newID;
  }

  render() {
    return (
      <>
        <Nav />
        <div className="hero">
          <h1 className="asdf">
            {(typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1) 
              ? `Taslaklar ( ${this.state.drafts.length} )` 
              : "Taslaklar Üssü"}
          </h1>
          <div className="drafts-center">
            <h2>Taslaklar ({this.state.drafts.length})</h2>
            <button onClick={this.yeniYazi}>+ Oluştur</button>
          </div>
          <div onClick={this.yeniYazi} className="artı" id="artı" style={{ display: "flex" }}>
            <div style={{ display: "none" }}>
              {this.state.buttonLabel}
              <div id="sjk" style={{ fontSize: "17px" }}></div>
            </div>
          </div>
          {this.state.showNoDraftsMessage && (
            <h2 className="h2" id="h2">Burada taslaklarını görebilirsin.</h2>
          )}
        </div>

        <div className="main">
          {this.state.drafts.length > 0 ? (
            this.state.drafts.map((draft) => (
              <Taslak 
                draftContent={draft.draftContent}
                draftTitle={draft.draftTitle}
                draftImage={draft.draftImage}
                draftAuthor={draft.draftAuthor}
                draftShared={draft.draftShared}
                draftId={draft.id}
                key={draft.id}
              />
            )).reverse()
          ) : (
            this.state.showLoading && <img src="/loading.svg" id="loading-non" className="loading-non" />
          )}
        </div>

        <style>{`
          .hero {
            background: url(/.png);
            background-size: cover;
            padding: 20px 100px;
            padding: 10px 0;
            margin: 0 auto;
            margin-top: 52px;
            max-width: 730px;
          }

          .asdf {
            text-align: center;
            margin: 50px 0;
            padding: 10px;
            font-size: 50px;
            user-select: none;
          }

          .drafts-center {
            width: max-content;
            margin: auto;
            display: flex;
          }

          .drafts-center h2 {
            margin: 0;
            line-height: 30px;
            user-select: none;
          }

          .drafts-center button {
            width: 30px;
            height: 30px;
            color: #fff;
            background: #2f2d33;
            border: none;
            border-radius: 100%;
            outline: none;
            margin-left: 10px;
            padding: 0;
            font-size: 20px;
            transition: .1s;
            user-select: none;
          }

          .drafts-center button:hover {
            background: #5b5b5c;
          }

          .artı {
            font-size: 20px;
            font-weight: bold;
            position: relative;
            margin-top: -2px;
            margin-right: 5px;
          }

          .h2 {
            margin: 30% 0;
            text-align: center;
            opacity: 0.5;
            display: none;
          }

          .edit {
            right: 15px;
            bottom: 10px;
            padding: 10px;
            z-index: 1;
            box-shadow: 0 0 0 2px #F57029;
            border-radius: 30px;
            background: #212121;
            color: #fff;
            position: fixed;
            outline: none;
            display: flex;
            cursor: pointer;
          }

          .edit:hover {
            background: #5b5b5c;
          }

          @media (max-width: 623px) {
            .main {
              padding-top: 65px;
              padding-bottom: 62px;
            }

            .asdf {
              margin: 0;
              margin-left: 10px;
              line-height: 50px;
              padding: 0;
              font-size: 20px;
              display: none;
            }

            .drafts-center {
              width: 100%;
              justify-content: space-around;
            }

            .drafts-center button { /*TODO - FIX THIS*/
              width: auto;
              display: flex;
              border-radius: 10px;
              font-size: 20px;
              padding: 4px 9px;
            }

            .artı {
              font-size: 30px;
              font-weight: bold;
              line-height: 50px;
              position: absolute;
              right: 10px;
            }

            .hero {
              width: 100%;
              position: fixed;
              z-index: 1;
              color: #fff;
              background: #2f2d33;
              height: 50px;
              padding: 0;
              margin: 0;
              display: flex;
            }

            .hero b {
              width: 155px;
              padding: 5px;
              background: #f57019;
              border-radius: 0 0 10px 0;
            }

            .edit {
              display: none;
            }
          }
        `}</style>
      </>
    );
  }
}

export default Taslaklar;
